import { Routes } from '@angular/router';
import { WelcomeComponent } from './features/auth/welcome/welcome.component';
import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { AlreadyLoggedInGuard } from './core/guards/already-logged-in/already-logged-in.guard';
import { PreventUrlManipulationGuard } from './core/guards/prevent-url-manipulation/prevent-url-manipulation.guard';

export const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '', component: WelcomeComponent },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent),
    canActivate: [AlreadyLoggedInGuard]
  },
  {
    path: 'register',
    loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'forgotpassword',
    loadComponent: () => import('./features/auth/forgotpassword/forgotpassword/forgotpassword.component').then(m => m.ForgotpasswordComponent)
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./features/admin/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent)
  },


  {
    path: '',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard, PreventUrlManipulationGuard],
    canActivateChild: [PreventUrlManipulationGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'pay-day-quick-view',
        loadComponent: () => import('./features/transactions/pay_day_view/pay-day-quick-view/pay-day-quick-view.component').then(m => m.PayDayQuickViewComponent)
      },

      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },

      {
        path: 'admin',
        children: [
          { path: '', redirectTo: 'company-details', pathMatch: 'full' },
          {
            path: 'company-details',
            loadComponent: () => import('./features/admin/company-details/company-details.component').then(m => m.CompanyDetailsComponent)
          },
          {
            path: 'company-details-view',
            loadComponent: () => import('./features/admin/company-details-view/company-details-view.component').then(m => m.CompanyDetailsViewComponent)
          },
                        {
                path: 'payroll-dashboard',
                loadComponent: () => import('./features/admin/payroll-dashboard/payroll-dashboard.component').then(m => m.PayrollDashboardComponent)
              },
          
          {
            path: 'user-management', children: [
              { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
              {
                path: 'existing-users',
                loadComponent: () => import('./features/admin/user-management/existing-users/existing-users.component').then(m => m.ExistingUsersComponent)
              },
              {
                path: 'existing-users/:adminId',
                loadComponent: () => import('./features/admin/user-management/view-edit-user/view-edit-user.component').then(m => m.ViewEditUserComponent)
              },
              {
                path: 'new-user-requests',
                loadComponent: () => import('./features/admin/user-management/new-user-requests/new-user-requests.component').then(m => m.NewUserRequestsComponent)
              },
              {
                path: 'new-user-requests/send',
                loadComponent: () => import('./features/admin/user-management/send-new-user-request/send-new-user-request.component').then(m => m.SendNewUserRequestComponent)
              },
              {
                path: 'new-user-requests/:requestId',
                loadComponent: () => import('./features/admin/user-management/view-new-user-request/view-new-user-request.component').then(m => m.ViewNewUserRequestComponent)
              },

            ]
          },
          {
            path: 'password-manage', children: [
              { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
              {
                path: 'dashboard',
                loadComponent: () => import('./features/admin/password-manage/password-dashboard/password-dashboard.component').then(m => m.PasswordDashboardComponent)
              },
              {
                path: 'select-user',
                loadComponent: () => import('./features/admin/password-manage/select-user/select-user.component').then(m => m.SelectUserComponent)
              },
            ]
          },
          {
            path: 'document-manage',
            loadComponent: () => import('./features/admin/document-manage/document-manage.component').then(m => m.DocumentManageComponent)
          }
        ]
      },

      {
        path: 'transactions',
        children: [
          { path: '', redirectTo: 'earned-wage-withdrawals', pathMatch: 'full' },
          {
            path: 'earned-wage-withdrawals', children: [
              {
                path: '',
                loadComponent: () => import('./features/transactions/earned_wage_withdrawal/pages/eww-dashboard/eww-dashboard.component').then(m => m.EwwDashboardComponent)
              },
              {
                path: ':companyId/:year/:month',
                loadComponent: () => import('./features/transactions/earned_wage_withdrawal/pages/eww-employees/eww-employees.component').then(m => m.EwwEmployeesComponent)
              },
              {
                path: ':companyId/:employeeId/:year/:month/daily-withdrawals',
                loadComponent: () => import('./features/transactions/earned_wage_withdrawal/pages/employee-daily-withdrawal/employee-daily-withdrawal.component').then(m => m.EmployeeDailyWithdrawalComponent)
              },
            ]
          },
          {
            path: 'wage-withdrawal-rollovers', children: [
              {
                path: '',
                loadComponent: () => import('./features/transactions/wage_withdrawal_rollovers/pages/wwr-dashboard/wwr-dashboard.component').then(m => m.WwrDashboardComponent)
              },
              {
                path: ':rolloverId',
                loadComponent: () => import('./features/transactions/wage_withdrawal_rollovers/pages/wwr-details/wwr-details.component').then(m => m.WwrDetailsComponent)
              },
            ]
          },
          {
            path: 'total-wages',
            loadComponent: () => import('./features/transactions/total_wages/pages/tw-dashboard/tw-dashboard.component').then(m => m.TwDashboardComponent)
          },
          {
            path: 'cixor-payments',
            loadComponent: () => import('./features/transactions/cixor_payments/pages/cp-dashboard/cp-dashboard.component').then(m => m.CpDashboardComponent)
          },
          {
            path: 'wages-withdrawals-rollovers',
            loadComponent: () => import('./features/transactions/wages_withdrawals_rollovers_summery/pages/wwr-summery-dashboard/wwr-summery-dashboard.component').then(m => m.WwrSummeryDashboardComponent)
          },
          {
            path: 'rollover-request',
            loadComponent: () => import('./features/transactions/pay_day_view/rollover-request/rollover-request.component').then(m => m.RolloverRequestComponent)
          },
          {
            path: 'pay-day-quick-view',
            loadComponent: () => import('./features/transactions/pay_day_view/pay-day-quick-view/pay-day-quick-view.component').then(m => m.PayDayQuickViewComponent)
          },
          {
            path: 'pay-day-quick-view/:companyId/historical/:salaryCycleId',
            loadComponent: () => import('./features/transactions/salary-cycle-history/salary-cycle-history.component').then(m => m.SalaryCycleHistoryComponent)
          },
          {
            path: 'late-payment-fees',
            loadComponent: () => import('./features/transactions/late-payment-fees/late-payment-fees.component').then(m => m.LatePaymentFeesComponent)
          },
        ]
      },
      {
        path: 'hr-link',
        children: [
          { path: '', redirectTo: 'login', pathMatch: 'full' },
          {
            path: 'login',
            loadComponent: () => import('./features/hr_link/hr-login/hr-login.component').then(m => m.HrLoginComponent)
          },
          {
            path: 'team-member',
            loadComponent: () => import('./features/hr_link/team-member/team-member.component').then(m => m.TeamMemberComponent)
          },
          {
            path: 'adding-member',
            loadComponent: () => import('./features/hr_link/adding-member/adding-member.component').then(m => m.AddingMemberComponent)
          },
          {
            path: 'absentee-recorder',
            loadComponent: () => import('./features/hr_link/absentee-recorder/absentee-recorder.component').then(m => m.AbsenteeRecorderComponent)
          },
          {
            path: 'emp-attendance',
            loadComponent: () => import('./features/hr_link/emp-attendance/emp-attendance.component').then(m => m.EmpAttendanceComponent)
          },
          {
            path: 'attendance-details',
            loadComponent: () => import('./features/hr_link/attendance-details/attendance-details.component').then(m => m.AttendanceDetailsComponent)
          },
                    {
            path: 'attendance-header',
            loadComponent: () => import('./features/hr_link/attendance-header/attendance-header.component').then(m => m.AttendanceHeaderComponent)
          },
          {
            path: 'leave-calendar-veiw/:empId',
            loadComponent: () => import('./features/hr_link/leave-calendar-view/leave-calendar-view.component').then(m => m.LeaveCalendarViewComponent)
          },
          {
            path: 'wage-report',
            loadComponent: () => import('./features/hr_link/wage-report/wage-report.component').then(m => m.WageReportComponent)
          },
          {
            path: 'employee-management',
            loadComponent: () => import('./features/hr_link/employee-management/employee-management.component').then(m => m.EmployeeManagementComponent)
          },
          {
            path: 'hr-admin',
            loadComponent: () => import('./features/hr_link/hr-admin/hr-admin.component').then(m => m.HrAdminComponent)
          },
          {
            path: 'hr-admin-buttons',
            loadComponent: () => import('./features/hr_link/hr-admin-buttons/hr-admin-buttons.component').then(m => m.HrAdminButtonsComponent)
          },
          {
            path: 'emp-management-buttons',
            loadComponent: () => import('./features/hr_link/emp-management-buttons/emp-management-buttons.component').then(m => m.EmpManagementButtonsComponent)
          },
          {
            path: 'onboard-req-approval',
            loadComponent: () => import('./features/hr_link/onboard-req-approval/onboard-req-approval.component').then(m => m.OnboardReqApprovalComponent)
          },
          {
            path: 'onboard-edit-req-approval',
            loadComponent: () => import('./features/hr_link/onboard-edit-req-approval/onboard-edit-req-approval.component').then(m => m.OnboardEditReqApprovalComponent)
          },
          {
            path: 'absentee-recorder-employees',
            loadComponent: () => import('./features/hr_link/absentee-recorder-employees/absentee-recorder-employees.component').then(m => m.AbsenteeRecorderEmployeesComponent)
          },
          {
            path: 'adding-leave',
            loadComponent: () => import('./features/hr_link/adding-leave/adding-leave.component').then(m => m.AddingLeaveComponent)
          },
          {
            path: 'payroll-management',
            loadComponent: () => import('./features/hr_link/payroll-management/payroll-management.component').then(m => m.PayrollManagementComponent)
          },
          {
            path: 'generate-payroll',
            loadComponent: () => import('./features/hr_link/generate-payroll/generate-payroll.component').then(m => m.GeneratePayrollComponent)
          },
          {
            path: 'bank-transfer-doc',
            loadComponent: () => import('./features/hr_link/bank-transfer-doc/bank-transfer-doc.component').then(m => m.BankTransferDocComponent)
          },
          {
            path: 'payroll-history',
            loadComponent: () => import('./features/hr_link/payroll-history/payroll-history.component').then(m => m.PayrollHistoryComponent)
          },
          {
            path: 'hr-setting',
            loadComponent: () => import('./features/hr_link/hr-setting/hr-setting.component').then(m => m.HrSettingComponent)
          },
          {
            path: 'salary-cycle',
            loadComponent: () => import('./features/hr_link/salary-cycle/salary-cycle.component').then(m => m.SalaryCycleComponent)
          },
          {
            path: 'salary-cycle-create',
            loadComponent: () => import('./features/hr_link/salary-cycle-create/salary-cycle-create.component').then(m => m.SalaryCycleCreateComponent)
          },
          {
            path: 'bulk-uploading',
            loadComponent: () => import('./features/hr_link/bulk-uploading/bulk-uploading.component').then(m => m.BulkUploadingComponent)
          },
          {
            path: 'generate-pay-slip',
            loadComponent: () => import('./features/hr_link/generate-pay-slip/generate-pay-slip.component').then(m => m.GeneratePaySlipComponent)
          },
          {
            path: 'company-calendar',
            loadComponent: () => import('./features/hr_link/company-calendar/company-calendar.component').then(m => m.CompanyCalendarComponent)
          },
          {
            path: 'leave-policy',
            loadComponent: () => import('./features/hr_link/leave-policy/leave-policy.component').then(m => m.LeavePolicyComponent)
          },
          {
            path: 'generate-bank-transfer-doc',
            loadComponent: () => import('./features/hr_link/generate-bank-transfer-doc/generate-bank-transfer-doc.component').then(m => m.GenerateBankTransferDocComponent)
          },
          {
            path: 'bank-transfer-doc-hiatory',
            loadComponent: () => import('./features/hr_link/bank-transfer-doc-hiatory/bank-transfer-doc-hiatory.component').then(m => m.BankTransferDocHiatoryComponent)
          },
          {
            path: 'epf-etf-doc',
            loadComponent: () => import('./features/hr_link/epf-etf-doc/epf-etf-doc.component').then(m => m.EpfEtfDocComponent)
          },
          {
            path: 'add-special-allowance',
            loadComponent: () => import('./features/hr_link/special-allowance/add-special-allowance/add-special-allowance.component').then(m => m.AddSpecialAllowanceComponent)
          },
          {
            path: 'special-allowance-type-requests',
            loadComponent: () => import('./features/hr_link/special-allowance/manage-special-allowance-type/manage-special-allowance-type.component').then(m => m.ManageSpecialAllowanceTypeComponent)
          },
          {
            path: 'special-allowance-requests',
            loadComponent: () => import('./features/hr_link/special-allowance/manage-special-allowance/manage-special-allowance.component').then(m => m.ManageSpecialAllowanceComponent)
          },
          {
            path: 'add-special-deduction',
            loadComponent: () => import('./features/hr_link/special-deduction/add-special-deduction/add-special-deduction.component').then(m => m.AddSpecialDeductionComponent)
          },
          {
            path: 'special-deduction-type-requests',
            loadComponent: () => import('./features/hr_link/special-deduction/manage-special-deduction-type/manage-special-deduction-type.component').then(m => m.ManageSpecialDeductionTypeComponent)
          },
          {
            path: 'special-deduction-requests',
            loadComponent: () => import('./features/hr_link/special-deduction/manage-special-deduction/manage-special-deduction.component').then(m => m.ManageSpecialDeductionComponent)
          },
          {
            path: 'payrolle-invoice',
            loadComponent: () => import('./features/hr_link/payrolle-invoice/payrolle-invoice.component').then(m => m.PayrolleInvoiceComponent)
          },
          {
            path: 'configuration',
            loadComponent: () => import('./features/hr_link/configuration/configuration.component').then(m => m.ConfigurationComponent)
          },
          {
            path: 'departments',
            loadComponent: () => import('./features/hr_link/department/department-list/department-list.component').then(m => m.DepartmentListComponent)
          },
          {
            path: 'department-form',
            loadComponent: () => import('./features/hr_link/department/department-form/department-form.component').then(m => m.DepartmentFormComponent)
          },
          {
            path: 'resign',
            loadComponent: () => import('./features/hr_link/resign/resign.component').then(m => m.ResignComponent)
          },
          {
            path: 'branch-configuration',
            loadComponent: () => import('./features/hr_link/branch-configuration/branch-configuration.component').then(m => m.BranchConfigurationComponent)
          },
          {
            path: 'transfer-emp',
            loadComponent: () => import('./features/hr_link/transfer-emp/transfer-emp.component').then(m => m.TransferEmpComponent)
          },
          {
            path: 'employee-tab-view',
            loadComponent: () => import('./features/hr_link/employee-tab-view/employee-tab-view.component').then(m => m.EmployeeTabViewComponent)
          },
          {
            path: 'employe-management-inactive-emp-tabs',
            loadComponent: () => import('./features/hr_link/employe-management-inactive-emp-tabs/employe-management-inactive-emp-tabs.component').then(m => m.EmployeManagementInactiveEmpTabsComponent)
          },
          {
            path: 'resign-new',
            loadComponent: () => import('./features/hr_link/resign-new/resign-new.component').then(m => m.ResignNewComponent)
          },
          {
            path: 'emp-view-all-tabs',
            loadComponent: () => import('./features/hr_link/emp-view-all-tabs/emp-view-all-tabs.component').then(m => m.EmpViewAllTabsComponent)
          },
          {
            path: 'active-emp',
            loadComponent: () => import('./features/hr_link/active-emp/active-emp.component').then(m => m.ActiveEmpComponent)
          },
          {
            path: 'inactive-emp',
            loadComponent: () => import('./features/hr_link/inactive-emp/inactive-emp.component').then(m => m.InactiveEmpComponent)
          },
          {
            path: 'all-emp',
            loadComponent: () => import('./features/hr_link/all-emp/all-emp.component').then(m => m.AllEmpComponent)
          },
          {
            path: 'terminate-emp',
            loadComponent: () => import('./features/hr_link/terminate-emp/terminate-emp.component').then(m => m.TerminateEmpComponent)
          },
          {
            path: 'transfer-emp-new',
            loadComponent: () => import('./features/hr_link/transfer-emp-new/transfer-emp-new.component').then(m => m.TransferEmpNewComponent)
          },
          {
            path: 'suspend-emp',
            loadComponent: () => import('./features/hr_link/suspend-emp/suspend-emp.component').then(m => m.SuspendEmpComponent)
          },
          {
            path: 'leave-request-table',
            loadComponent: () => import('./features/hr_link/leave-request-table/leave-request-table.component').then(m => m.LeaveRequestTableComponent)
          },
          {
            path: 'leave-req-review',
            loadComponent: () => import('./features/hr_link/leave-req-review/leave-req-review.component').then(m => m.LeaveReqReviewComponent)
          },
          {
            path: 'hr-support-messages',
            loadComponent: () => import('./features/hr_link/hr-support-messages/hr-support-messages.component').then(m => m.HrSupportMessagesComponent)
          },
          {
            path: 'hr-support-messages/employee/:employeeId',
            loadComponent: () => import('./features/hr_link/hr-support-messages/hr-support-employee-chats/hr-support-employee-chats.component').then(m => m.HrSupportEmployeeChatsComponent)
          },
          {
            path: 'hr-support-conversation/:id',
            loadComponent: () => import('./features/hr_link/hr-support-messages/hr-support-conversation/hr-support-conversation.component').then(m => m.HrSupportConversationComponent)
          }
        ]
      },
    ],
  },
];
